import {
  AI_PROMPT_BUILDER_CREATE_PAGE_BEGIN,
  AI_PROMPT_BUILDER_CREATE_PAGE_SUCCESS,
  AI_PROMPT_BUILDER_CREATE_PAGE_FAILURE,
  AI_PROMPT_BUILDER_CREATE_PAGE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createPage(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_CREATE_PAGE_BEGIN,
    });

    const { projectId, version, data } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: AI_PROMPT_BUILDER_CREATE_PAGE_SUCCESS,
              data: res,
            });
            const { uuid, name } = res.data;
            Mixpanel.track('Created Page on builder', { name, uuid });
            resolve(res.data);
          } else {
            dispatch({
              type: AI_PROMPT_BUILDER_CREATE_PAGE_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Create page failed on builder');
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_CREATE_PAGE_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Create page failed on builder');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreatePageError() {
  return {
    type: AI_PROMPT_BUILDER_CREATE_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_CREATE_PAGE_BEGIN:
      return {
        ...state,
        createPagePending: true,
        createPageError: null,
      };

    case AI_PROMPT_BUILDER_CREATE_PAGE_SUCCESS:
      return {
        ...state,
        createPagePending: false,
        createPageError: null,
      };

    case AI_PROMPT_BUILDER_CREATE_PAGE_FAILURE:
      return {
        ...state,
        createPagePending: false,
        createPageError: action.data.error,
      };

    case AI_PROMPT_BUILDER_CREATE_PAGE_DISMISS_ERROR:
      return {
        ...state,
        createPageError: null,
      };

    default:
      return state;
  }
}
